import { render, staticRenderFns } from "./EditPrivacyPolicyModal.vue?vue&type=template&id=f4c5238e&scoped=true"
import script from "./EditPrivacyPolicyModal.vue?vue&type=script&lang=js"
export * from "./EditPrivacyPolicyModal.vue?vue&type=script&lang=js"
import style0 from "./EditPrivacyPolicyModal.vue?vue&type=style&index=0&id=f4c5238e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4c5238e",
  null
  
)

export default component.exports